export default __webpack_public_path__ + "static/gdrive-hero-img-65d9e033ce53d617d9ee39af7cf097e2.png";